<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Anniversary of Martyrdom of Father of the Nation Bangabandhu Sheikh
      Mujibur Rahman
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        Observing Anniversary of Martyrdom of Father of the Nation Bangabandhu
        Sheikh Mujibur Rahman and National Mourning Day at Proyash-Chattogram.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
